import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import {
    FormInputComponent,
    InputComponentConfig,
    DataService,
    NotificationService,
} from '@vendure/admin-ui/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
    VariantWithDiscount,
    VariantWithDiscountArgPayload,
} from './helpers/types';

@Component({
    standalone: true,
    selector: 'variants-discount-form-input',
    imports: [CommonModule, ReactiveFormsModule, FormsModule],
    template: `
        <div class="container" *ngFor="let variant of variants">
            <div>
                <div *ngIf="variant.featuredAsset">
                    <img
                        [src]="variant.featuredAsset.source"
                        alt="Product Variant"
                        width="20"
                    />
                </div>
                <div class="informations">
                    <span>ID: {{ variant.id }}</span>
                    <span>SKU: {{ variant.sku }}</span>
                </div>
            </div>
            <span
                >Desconto exercido neste produto: {{ variant.discount }}%</span
            >
        </div>
    `,
    styles: [
        `
            img {
                width: 20%;
            }

            .informations {
                display: flex;
                flex-direction: column;
                justify-content: center;
            }

            .container {
                margin-bottom: 30px;
            }

            .custom-button {
                margin-left: 20px;
            }
        `,
    ],
})
export class VariantsDiscountFormInput
    implements FormInputComponent<InputComponentConfig>, OnInit
{
    @Input() readonly: boolean = false;
    @Input() formControl!: FormControl;
    @Input() config!: InputComponentConfig;

    variants: VariantWithDiscount[] = [];

    constructor(
        private dataService: DataService,
        private notificationService: NotificationService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.searchVariantByIds();
    }

    searchVariantByIds(): void {
        const data: VariantWithDiscountArgPayload[] = this.formControl.value;

        const variantIds = data.map((item) => item.variantId.toString());
        this.dataService.product
            .getProductVariants({
                filter: { id: { in: variantIds } },
            })
            .mapStream((response) => response.productVariants.items)
            .subscribe({
                next: (variants) => {
                    this.variants = variants.map((variant) => {
                        const discount = data.find(
                            (v) => v.variantId == variant.id
                        );

                        return {
                            ...variant,
                            discount: discount?.discount || 0,
                        };
                    });

                    this.cd.detectChanges();
                },
                error: (err) => {
                    this.notificationService.error(
                        'Erro ao buscar variantes: ',
                        err
                    );
                },
            });
    }
}
